import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FollowLayoutComponent } from './containers/follow-layout/follow-layout.component';
import { FollowHeaderComponent } from './components/follow-header/follow-header.component';
import { FollowRoutingModule } from '@app/modules/follow/follow-routing.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { StoreModule } from '@ngrx/store';
import { reducers } from './reducers';
@NgModule({
  imports: [
    CommonModule,
    FollowRoutingModule,
    NgbModule,
    StoreModule.forFeature('followModule', reducers)
  ],
  declarations: [FollowLayoutComponent, FollowHeaderComponent],
  exports: [FollowLayoutComponent, FollowHeaderComponent]
})
export class FollowModule {}
